import { ContractServices } from 'network'
import { useChangeLanguage } from '../hooks/use-change-language'
import { storageDB, StorageIndexDBEnum } from '../storage/StorageDB'
import { APP_CONFIG } from '../../../crypto-otc/src/project-config'
import { useBaseInfoStore } from './use-base-info'

export const useExchangeInfoStore = defineStore('exchangeInfo', () => {
  const exchangeInfo = ref<ApiResponse.ContractExchangeInfo>()
  const loading = ref(false)
  const baseInfoStore = useBaseInfoStore()

  const getExchangeInfo = async () => {
    if (!APP_CONFIG.isExchange) return
    if (loading.value) return
    loading.value = true
    storageDB.cacheFetch(StorageIndexDBEnum.ExchangeInfo, {
      fetch: () => ContractServices.getExchangeInfo(),
      callback: (res) => {
        exchangeInfo.value = res
        loading.value = false
      },
    })
  }

  const getContractSymbolName = (symbolId: SymbolId) => {
    const symbol = exchangeInfo.value?.symbols.find((item) => item.symbolId === symbolId)
    if (!symbol) return ''
    return symbol.symbolName
  }

  const getContractSymbolInfoByBaseItemIdAndMarginItemId = (baseItemId: ItemId, marginItemId: ItemId) => {
    return exchangeInfo.value?.symbols.find((item) => {
      return item.contractItemId === baseItemId && item.marginItemId === marginItemId
    })
  }

  const getContractSymbolInfoBySymbolId = (symbolId: SymbolId) => {
    return exchangeInfo.value?.symbols.find((item) => item.symbolId === symbolId)
  }

  const getFromSymbolNameBySymbolId = (symbolId: SymbolId) => {
    const symbol = getContractSymbolInfoBySymbolId(symbolId)
    if (!symbol) return ''
    const itemId = symbol.contractItemId
    const baseInfo = baseInfoStore.getCoinInfoByItemId(itemId)
    if (!baseInfo) return ''
    return baseInfo.itemName.toUpperCase()
  }

  const getToSymbolNameBySymbolId = (symbolId: SymbolId) => {
    const symbol = getContractSymbolInfoBySymbolId(symbolId)
    if (!symbol) return ''
    const itemId = symbol.marginItemId
    const baseInfo = baseInfoStore.getCoinInfoByItemId(itemId)
    if (!baseInfo) return ''
    return baseInfo.itemName.toUpperCase()
  }

  const getDisplaySymbolNameBySymbolId = (symbolId: SymbolId) => {
    const symbol = getContractSymbolInfoBySymbolId(symbolId)
    if (!symbol) return ''
    const itemId = symbol.contractItemId
    const baseInfo = baseInfoStore.getCoinInfoByItemId(itemId)
    if (!baseInfo) return ''
    console.log(baseInfo.itemDetail)
    return baseInfo.itemDetail.explain
  }

  const getMaintMarginRateBySymbolId = (symbolId: SymbolId) => {
    const symbol = getContractSymbolInfoBySymbolId(symbolId)
    if (!symbol) return []
    return symbol.maintMarginRate
  }

  useChangeLanguage(getExchangeInfo)

  return {
    exchangeInfo,
    getContractSymbolName,
    getContractSymbolInfoByBaseItemIdAndMarginItemId,
    getContractSymbolInfoBySymbolId,
    getExchangeInfo,
    getFromSymbolNameBySymbolId,
    getToSymbolNameBySymbolId,
    getDisplaySymbolNameBySymbolId,
    getMaintMarginRateBySymbolId,
  }
})
